import { render, staticRenderFns } from "./degreeSubject.vue?vue&type=template&id=732897da&scoped=true&"
import script from "./degreeSubject.vue?vue&type=script&lang=js&"
export * from "./degreeSubject.vue?vue&type=script&lang=js&"
import style0 from "./degreeSubject.vue?vue&type=style&index=0&id=732897da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732897da",
  null
  
)

export default component.exports